import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
//	serverUrl: 'http://www.dev.caomeijiang.net',   //开发
	serverUrl: 'http://www.test.caomeijiang.net',   //测试
//	serverUrl: 'https://www.caomeijiang.net',   //生产
	imgUrl: 'http://cdn.caomeijiang.net',
	activeUrl: 'http://www.test.active.caomeijiang.net',   //测试
//	activeUrl: 'http://www.active.caomeijiang.net',   //生产
	auth: '',
	info: {
		openid : '',
        channelid : '',
        deviceid : '',
        appversion : ''
	}
}

const mutations = {
    changeAuth(state, auth){
        state.auth = auth;
    },
    
    changeInfo(state, info){
        state.info = info;
    }
}
export default new Vuex.Store({
	state,
	mutations
});


// WEBPACK FOOTER //
// ./src/store.js